import AppState from '@webapp/store/state';

export const getTrackIdFromPath = (state: AppState): string => {
  const path = state.router.location.pathname;
  const exp = /^\/release\/[^/]+\/[^/]+\/track\/([^/]+)/; // matches /release/<artist-id>/<release-id>/track/(<track-id>)

  const match = path.match(exp);

  if (match) {
    return match[1];
  }

  return '';
};
